<template>
	<b-input-group>
			<b-form-select ref="hourPicker" class="text-center" :options="hourOptions" v-model="hour"></b-form-select>
			<b-input-group-prepend is-text>:</b-input-group-prepend>
			<b-form-select ref="minutePicker"  class="text-center"  :options="minuteOptions" v-model="minute" ></b-form-select>
			<!-- <b-form-select ref="meridiemPicker"  class="text-center"  :options="meridiemOptions" v-model="meridiem"></b-form-select> -->
	</b-input-group>
</template>

<script>
export default {
	props: ['value'],
	data() {
		return {
			hour:null,
			minute:null,
			meridiem:null,
			fullDate: null,
			utc:null
		}
	},
	computed: {

		hourOptions() {
			return [
			{ value:'0'   , text:"0"},
			{ value:'1'   , text:"01"},
			{ value:'2'   , text:"02"},
			{ value:'3'   , text:"03"},
			{ value:'4'   , text:"04"},
			{ value:'5'   , text:"05"},
			{ value:'6'   , text:"06"},
			{ value:'7'   , text:"07"},
			{ value:'8'   , text:"08"},
			{ value:'9'   , text:"09"},
			{ value:'10'   , text:"10"},
			{ value:'11'   , text:"11"},
			{ value:'12'   , text:"12"},
			{ value:'13'   , text:"13"},
			{ value:'14'   , text:"14"},
			{ value:'15'   , text:"15"},
			{ value:'16'   , text:"16"},
			{ value:'17'   , text:"17"},
			{ value:'18'   , text:"18"},
			{ value:'19'   , text:"19"},
			{ value:'20'   , text:"20"},
			{ value:'21'   , text:"21"},
			{ value:'22'   , text:"22"},
			{ value:'23'   , text:"23"},
			];
		},
		minuteOptions() {
			return [
			{ value:'00'   , text:"00"},
			{ value:'01'   , text:"01"},
			{ value:'02'   , text:"02"},
			{ value:'03'   , text:"03"},
			{ value:'04'   , text:"04"},
			{ value:'05'   , text:"05"},
			{ value:'06'   , text:"06"},
			{ value:'07'   , text:"07"},
			{ value:'08'   , text:"08"},
			{ value:'09'   , text:"09"},
			{ value:'10'   , text:"10"},
			{ value:'11'   , text:"11"},
			{ value:'12'   , text:"12"},
			{ value:'13'   , text:"13"},
			{ value:'14'   , text:"14"},
			{ value:'15'   , text:"15"},
			{ value:'16'   , text:"16"},
			{ value:'17'   , text:"17"},
			{ value:'18'   , text:"18"},
			{ value:'19'   , text:"19"},
			{ value:'20'   , text:"20"},
			{ value:'21'   , text:"21"},
			{ value:'22'   , text:"22"},
			{ value:'23'   , text:"23"},
			{ value:'24'   , text:"24"},
			{ value:'25'   , text:"25"},
			{ value:'26'   , text:"26"},
			{ value:'27'   , text:"27"},
			{ value:'28'   , text:"28"},
			{ value:'29'   , text:"29"},
			{ value:'30'   , text:"30"},
			{ value:'31'   , text:"31"},
			{ value:'32'   , text:"32"},
			{ value:'33'   , text:"33"},
			{ value:'34'   , text:"34"},
			{ value:'35'   , text:"35"},
			{ value:'36'   , text:"36"},
			{ value:'37'   , text:"37"},
			{ value:'38'   , text:"38"},
			{ value:'39'   , text:"39"},
			{ value:'40'   , text:"40"},
			{ value:'41'   , text:"41"},
			{ value:'42'   , text:"42"},
			{ value:'43'   , text:"43"},
			{ value:'44'   , text:"44"},
			{ value:'45'   , text:"45"},
			{ value:'46'   , text:"46"},
			{ value:'47'   , text:"47"},
			{ value:'48'   , text:"48"},
			{ value:'49'   , text:"49"},
			{ value:'50'   , text:"50"},
			{ value:'51'   , text:"51"},
			{ value:'52'   , text:"52"},
			{ value:'53'   , text:"53"},
			{ value:'54'   , text:"54"},
			{ value:'55'   , text:"55"},
			{ value:'56'   , text:"56"},
			{ value:'57'   , text:"57"},
			{ value:'58'   , text:"58"},
			{ value:'59'   , text:"59"}
			]
		},
		meridiemOptions() {
			return [
			{ value:'am'   , text:"AM"},
			{ value:'pm'   , text:"PM"}
			];
		}

	},
	watch: {
		'value':function(evt) {
			const theDate = this.moment(evt);
			this.hour = theDate.format("H");
			this.minute = theDate.format("mm");
			this.meridiem = theDate.format("a");
		},
		'hour':function() {
			this.updateTime();
		}
		,
		'minute':function() {
			this.updateTime();
		}
		,
		'meridiem':function() {
			this.updateTime();
		}
	},
	mounted() {
		const theDate = this.moment(this.value);
		this.hour = theDate.format("H");
		this.minute = theDate.format("mm");
		this.meridiem = theDate.format("a");

	},
	// Sets the display value on creation
	methods: {
		updateTime() {
			let theDate = null;

			if (this.value == null) {
				theDate = this.moment();
			} else {
				theDate = this.moment(this.value);
			}
			theDate.hour(parseInt(this.hour, 10));
			/*
			if (this.meridiem == "pm" ) {
				if (parseInt(this.hour, 10) == 12) {
					theDate.hour(12);
				} else {
					theDate.hour(parseInt(this.hour, 10) + 12);
				}
			} else {
				if (parseInt(this.hour, 10) == 12) {
					theDate.hour(0);
				} else {
					theDate.hour(parseInt(this.hour, 10));
				}
			}
			*/
			theDate.minute(parseInt(this.minute, 10));
			theDate.second(0);
			this.fullDate = theDate.format();
			this.$emit('update:time',this.fullDate);
			this.$emit('input',this.fullDate);
		},


	}
};
</script>
